import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-reporting',
  host: {
    class: 'flex-grow-1'
  },
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/developer/reporting/reporting.component.ts